(function () {
  var KEY = 'pearl_wishlist';
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-8-5.2-8-11a4.5 4.5 0 0 1 8-2.8A4.5 4.5 0 0 1 20 10c0 5.8-8 11-8 11z"/></svg>';
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var list = [];
  try { var saved = JSON.parse(localStorage.getItem(KEY)); if (Array.isArray(saved)) list = saved; } catch (e) {}
  function write() { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }
  var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
  function money(c) { try { return new Intl.NumberFormat('en-IN', { style: 'currency', currency: cur, maximumFractionDigits: 0 }).format(c / 100); } catch (e) { return String(Math.round(c / 100)); } }
  function setText(el, t) { if (el.textContent !== t) el.textContent = t; }

  function sync() {
    $$('[data-wish]').forEach(function (b) {
      var on = list.indexOf(b.dataset.wish) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var l = b.querySelector('[data-wish-label]');
      if (l) setText(l, on ? 'Saved to wishlist' : 'Save to wishlist');
    });
    $$('[data-wish-count]').forEach(function (c) { setText(c, String(list.length)); c.hidden = !list.length; });
  }

  var drawer = document.querySelector('[data-wish-drawer]');
  var box = drawer && drawer.querySelector('[data-wish-items]');
  function msg(t) { box.textContent = ''; var p = document.createElement('p'); p.className = 'cempty'; p.textContent = t; box.appendChild(p); }
  var EMPTY = 'Nothing saved yet. Tap the heart on any product.';

  function actionsFor(p) {
    var wrap = document.createElement('div'); wrap.className = 'witem__actions';
    var locked = (p.tags || []).indexOf('locked') > -1;
    if (locked) {
      var a = document.createElement('a'); a.href = p.url; a.className = 'witem__add witem__add--link'; a.textContent = 'Unlock to view';
      wrap.appendChild(a); return wrap;
    }
    var avail = (p.variants || []).filter(function (v) { return v.available; });
    var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'witem__add';
    if (!avail.length) { btn.disabled = true; btn.textContent = 'Sold out'; wrap.appendChild(btn); return wrap; }
    btn.textContent = 'Add to bag';
    btn.setAttribute('data-add-variant', avail[0].id);
    if (p.variants.length > 1) {
      var sel = document.createElement('select'); sel.className = 'witem__sel'; sel.setAttribute('aria-label', 'Choose option for ' + p.title);
      avail.forEach(function (v) { var o = document.createElement('option'); o.value = v.id; o.textContent = v.title; sel.appendChild(o); });
      sel.addEventListener('change', function () { btn.setAttribute('data-add-variant', sel.value); });
      wrap.appendChild(sel);
    }
    wrap.appendChild(btn);
    return wrap;
  }

  function render() {
    if (!box) return;
    if (!list.length) { msg(EMPTY); return; }
    msg('Loading...');
    Promise.all(list.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : (r.status === 404 ? null : false); })
        .catch(function () { return false; });
    })).then(function (items) {
      var keep = [];
      box.textContent = '';
      items.forEach(function (p, i) {
        if (p === false) { keep.push(list[i]); return; }
        if (!p) return;
        keep.push(list[i]);
        var row = document.createElement('div'); row.className = 'witem';
        var a = document.createElement('a'); a.href = p.url; a.className = 'witem__img';
        if (p.featured_image) {
          var im = document.createElement('img');
          im.src = p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=160';
          im.alt = p.title; im.loading = 'lazy'; a.appendChild(im);
        }
        var info = document.createElement('div');
        var t = document.createElement('a'); t.href = p.url; t.className = 'witem__t'; t.textContent = p.title;
        var pr = document.createElement('p'); pr.className = 'witem__p'; pr.textContent = money(Math.max(p.price, p.compare_at_price || 0));
        info.appendChild(t); info.appendChild(pr); info.appendChild(actionsFor(p));
        var rm = document.createElement('button'); rm.type = 'button'; rm.className = 'witem__rm'; rm.setAttribute('data-wish-remove', p.handle); rm.textContent = 'Remove';
        row.appendChild(a); row.appendChild(info); row.appendChild(rm); box.appendChild(row);
      });
      if (keep.length !== list.length) { list = keep; write(); sync(); }
      if (!box.children.length) msg(EMPTY);
    });
  }

  function openDrawer() {
    if (!drawer) return;
    $$('.drawer').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
    var s = document.querySelector('[data-scrim]'); if (s) s.hidden = false;
    render(); drawer.focus();
  }

  function toggle(h) {
    var i = list.indexOf(h);
    if (i > -1) list.splice(i, 1); else list.push(h);
    write(); sync();
  }

  window.pearlWishlist = {
    has: function (h) { return list.indexOf(h) > -1; },
    add: function (h) { if (list.indexOf(h) < 0) { list.push(h); write(); sync(); } }
  };

  document.addEventListener('click', function (e) {
    var w = e.target.closest('[data-wish]');
    if (w) { e.preventDefault(); toggle(w.dataset.wish); return; }
    var rm = e.target.closest('[data-wish-remove]');
    if (rm) { toggle(rm.getAttribute('data-wish-remove')); render(); return; }
    if (e.target.closest('[data-wish-open]')) openDrawer();
  });

  /* heart button on the product page, under the title */
  var sec = document.querySelector('[data-product-section]');
  if (sec) {
    var j = sec.querySelector('[data-product-json]'), ttl = sec.querySelector('.pdp__title');
    if (j && ttl) {
      try {
        var pd = JSON.parse(j.textContent);
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'wish wish--pdp'; b.setAttribute('data-wish', pd.handle);
        b.innerHTML = HEART + '<span data-wish-label>Save to wishlist</span>';
        ttl.insertAdjacentElement('afterend', b);
      } catch (e) {}
    }
  }

  sync();
  var timer;
  new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(sync, 120); }).observe(document.body, { childList: true, subtree: true });
})();
